import ImportIcon from './ImportIcon'

export default ImportIcon
